import React from "react";
import PropTypes from "prop-types";
import Formsy from "formsy-react";
import { objToArr } from "../../helpers";
import Select from "../Formsy/Select";
import Input from "../Formsy/Input";
import InspectorSection from "./InspectorSection";
import theme from "../../themes/green";

class PortalWidgetEditor extends React.Component {
  constructor() {
    super();
    this.state = {
      canSubmit: false
    };

    this.triggerSubmit = this.triggerSubmit.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  resetForm(event) {
    event.preventDefault();
  }

  switchAutoSubmit(canSubmit) {
    this.setState({ canSubmit });
  }

  autoSubmit() {
    setTimeout(() => {
      if (this.state.canSubmit) {
        this.form.submit();
      }
    }, 500);
  }

  triggerSubmit(event, data) {
    /*
    this.form.submit(); */
  }

  onValidSubmit(data) {
    /* const preparedData = Object.assign({}, data);
    preparedData.target = data.target.key; */
    if (data.targetScene) {
      this.props.onValidSubmit(data, this.props.path);
    }
  }

  render() {
    const options = objToArr(this.props.project.scenes).map(item => ({
      label: item.name,
      rotation: item.rotation,
      value: item.key
    }));
    return (
      <Formsy
        onValid={() => {
          this.switchAutoSubmit(true);
        }}
        onInvalid={() => {
          this.switchAutoSubmit(false);
        }}
        onValidSubmit={this.onValidSubmit}
        onChange={() => {
          this.autoSubmit();
        }}
        style={{ width: "100%" }}
        ref={component => {
          this.form = component;
        }}
      >
        <InspectorSection hideHeader>
          <Input
            name="name"
            placeholder="Widget name..."
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={this.props.element.name}
          />
        </InspectorSection>
        <InspectorSection title="TARGET" onResetClick={this.resetForm}>
          <Select
            name="targetScene"
            options={options}
            value={this.props.element.targetScene}
          />
        </InspectorSection>
        <InspectorSection title="TRANSFORM">
          <Input
            name="size"
            placeholder="Size"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={this.props.element.size ? this.props.element.size : "200px"}
          />
          <Input
            name="rotation"
            placeholder="Rotation"
            required
            style={{
              color: theme.pallete.background,
              borderBottom: `2px solid ${theme.pallete.lightBackground}`,
              wrapper: { margin: 0 }
            }}
            /* forceBackground */
            value={
              this.props.element.rotation ? this.props.element.rotation : "70"
            }
          />
        </InspectorSection>
      </Formsy>
    );
  }
}

PortalWidgetEditor.propTypes = {
  path: PropTypes.string.isRequired,
  element: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  onValidSubmit: PropTypes.func
};

PortalWidgetEditor.defaultProps = {
  onValidSubmit: () => {}
};

export default PortalWidgetEditor;



// WEBPACK FOOTER //
// ./src/components/Inspector/portalWidgetEditor.js